import React, { Component } from "react";
import { Row, Col, Tooltip } from "antd";
import F from "../Functions";

class CreateBfileList extends Component {
  render() {
    const { list_info, noValue } = this.props;
    F.log("recommended_limit==>>" + JSON.stringify(list_info));
    return (
      <Row gutter={[16, 16]} style={{ display: "flex", flexWrap: "wrap" }} >
        {list_info.map((ha, i) => {
          const haValue = F.dollar_format(ha.value);
          const haValueList =
            haValue != null &&
            haValue != "" &&
            haValue != "$NaN";
          return haValueList || noValue ? (
            <Col span={5}
              xs={24}  // full width on mobile
              sm={12}  // 2 per row on tablets
              md={8}   // 3 per row on small desktops
              lg={6}   // 4 per row on large desktops
              xl={5}   // close to your original span
              className="rac_list_card">

              <div className="icon">
                <img
                  src={ha.icon}
                  alt={ha.title}
                />
              </div>
              <div className="title">
                {ha.title}
              </div>
              {!noValue && <div className="value">
                <Tooltip title={ha.value}>
                  {haValue}
                </Tooltip>
              </div>}
            </Col>
          ) : null;
        })}
      </Row>
    );
  }
}

export default CreateBfileList;



// WEBPACK FOOTER //
// ./src/components/create-bfile-list.js